/**
 * @param {function} callback
 * @param {int} delay
 */
const debounce = (callback, delay = 250) => {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};

export default debounce;
